module.exports = __webpack_public_path__ + "img/favicon.2954be53.ico";